// Auto-generated file - do not edit manually
export const LOCALE_HASH = '85543d2f';
